import { mutate } from "swr"

import useCollection from "./useCollection"
import API from "./api"

export default function useFormSections({ subjectType, topicId = "none" }) {
  const key = `/form_sections/${subjectType}/${topicId || "none"}`
  const updatePath = "/form_sections"

  const data = useCollection({ key, updatePath })

  async function reorderSections(from, to) {
    mutate(key, API.post(`${key}/reorder`, { from, to }))
  }

  function reorderFields(sectionId) {
    return async (from, to) => {
      await API.post(`/form_sections/${sectionId}/reorder_fields`, { from, to })
      mutate(key)
    }
  }

  for (const el of data) {
    el.reorderFields = reorderFields(el.id)
  }

  data.reorder = reorderSections

  return data
}
